import React from "react";

import clsx from "clsx";

import { CheckIcon } from "@heroicons/react/outline";

import HeaderCell from "./headerCell";
import styles from "./index.module.css";
import { IntegrationFeature, IntegratorItem, RankedTableProps } from "./types";

type IntegratorCellsProps = { integrator: IntegratorItem; feature: IntegrationFeature };
const IntegratorCells = ({ integrator, feature }: IntegratorCellsProps) => {
  const integrationValue = feature.integrators?.find(i => i.item._ref === integrator._id);
  return (
    <div className={styles.integrationCell}>
      <div className={styles.integrationContent}>
        {!!integrationValue &&
          (integrationValue?.detail || (
            <div
              className="inline-block p-1.5 rounded-full shadow-md bg-secondary text-white"
              aria-label={`${integrator.name} Supported`}
            >
              <CheckIcon className="h-3 w-3 md:h-5 md:w-5" />
            </div>
          ))}
      </div>
    </div>
  );
};

const DesktopChart = ({ integratorsList, features, title, className }: RankedTableProps) => (
  <div
    className={clsx(
      "hidden md:block overflow-x-auto rounded-b-lg shadow-md bg-white border border-gray-200 max-h-[80vh]",
      className
    )}
  >
    <div className="sticky top-0 border-b border-gray-300 z-[2]">
      <div className="flex">
        <div className={clsx(styles.featureCell, "text-lg font-bold text-left")}>{title}</div>
        {integratorsList.map((integrator, index) => (
          <div key={integrator._id || index} className={styles.integrationCell}>
            <HeaderCell integrator={integrator} />
          </div>
        ))}
      </div>
      <div className="flex">
        <div className={clsx(styles.rankDescriptionCell, "text-left flex items-center flex-wrap")}>
          <span className="text-lg font-bold pr-2 leading-5">Integration Rank</span>{" "}
          <span className="text-xs font-medium md:whitespace-nowrap mt-0.5">(By Number of Features/Capabilities)</span>
        </div>
        {integratorsList.map((integrator, index) => (
          <div key={integrator._id || index} className={styles.rankCell}>
            #{index + 1}
          </div>
        ))}
      </div>
    </div>
    <div>
      {features.map((feature, index) => (
        <div key={feature._id || index} className={styles.featureRow}>
          <div className={clsx(styles.featureCell, "flex flex-col justify-center")}>
            <p>{feature.title}</p>
            {feature.description && <p className="text-gray-500 text-sm mt-1">{feature.description}</p>}
          </div>
          {integratorsList.map((integrator, integratorIndex) => (
            <IntegratorCells key={integrator._id || integratorIndex} integrator={integrator} feature={feature} />
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default DesktopChart;
